<template>
    <div class="container d-flex justify-content-center text-center">
        <h2 class="text-white mt-5">
            {{ $t("label.unsubscribe") }}
        </h2>
    </div>
</template>

<script>
    import api from '@/api';
    import UrlUtils from './mixins/UrlUtils';

    export default {
        name: 'Unsubscribe',

        data() {
            return {
                confirmed: true
            };
        },

        async created() {
            if (this.$route.query.token) {
                await api.post('/app/unsubscribe/', {
                    token: this.$route.query.token
                });
            }
            else {
                this.openRelativeUrl('/');
            }
        }
    };
</script>
